import React from 'react';
import ReactDOM from 'react-dom';
import { ThemeProvider as MuiThemeProvider } from '@mui/material/styles';
import { ThemeProvider as SCThemeProvider } from "styled-components";
import { Provider as StoreProvider } from 'react-redux';
import { CssBaseline } from '@mui/material';

import './index.css';
import reportWebVitals from './reportWebVitals';
import { BrowserRouter } from 'react-router-dom';
import theme from './common/theme';
import store from './store';
import { AppRouting } from './AppRouting';

ReactDOM.render(
  <React.StrictMode>
    <StoreProvider store={store}>
      <BrowserRouter>
        {/* <ConnectedRouter history={history}> */}
        <MuiThemeProvider theme={theme}>
          <SCThemeProvider theme={theme}>
            <CssBaseline />
            <AppRouting />
          </SCThemeProvider>
        </MuiThemeProvider>
        {/* </ConnectedRouter> */}
      </BrowserRouter>
    </StoreProvider>
  </React.StrictMode>,
  document.getElementById('root')
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
